import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import BodyContent from "./BodyContent";
import '../style/UserForm.css'; // Import your CSS file
import './Layout.css'; // Import a new CSS file for styling

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const isDashboard = location.pathname === "/dashboard";

  return (
    <div className={`layout ${isDashboard ? "dashboard-layout" : ""}`}>
      <Header />
      <div id="bodyDiv">
        <main className="main-content">{children}</main>
        {!isDashboard && (
          <div id="bodyRcontentDiv" className="right-content">
            <div className="video-background">
              <video autoPlay muted loop className="background-video">
                <source src={`${process.env.PUBLIC_URL}/intorVideo.mp4`} type="video/mp4" />
                Your browser does not support the video tag. Please upgrade your browser.
              </video>
              <div className="content-overlay">
                <h1>Welcome to Ariseupp7</h1>
                <p>&nbsp;</p>
                <h2>Ariseupp 7 – Your Path to Growth, Health, and Sustainable Living!</h2>
              </div>
            </div>
          </div>
        )}
      </div>
      
      <BodyContent />
      <Footer />
    </div>
  );
};

export default Layout;
